const ready = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};

const slugify = (value) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const showStoreReviewsOnly = () => {
  if (!document.body.matches('.template-product')) return;

  const mainContent = document.getElementById('MainContent') || document.body;
  let observer;

  const activateStoreReviews = () => {
    const widget = document.getElementById('judgeme_product_reviews');
    const storeReviewsTab = widget?.querySelector('#jdgm-tab_shop_reviews');
    if (!widget || !storeReviewsTab) return false;

    widget.classList.add('cactus-store-reviews-only');

    const heading = widget.querySelector('.jm-review-widget-minimal-header__title');
    if (heading && heading.textContent.trim() !== 'Store Reviews') heading.textContent = 'Store Reviews';

    if (storeReviewsTab.getAttribute('aria-selected') !== 'true') storeReviewsTab.click();

    return storeReviewsTab.getAttribute('aria-selected') === 'true';
  };

  if (activateStoreReviews()) return;

  observer = new MutationObserver(() => {
    if (!activateStoreReviews()) return;
    observer.disconnect();
  });

  observer.observe(mainContent, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
};

ready(() => {
  document.querySelectorAll('h1, h2, h3, h4').forEach((heading) => {
    if (!heading.textContent.trim()) heading.remove();
  });

  showStoreReviewsOnly();

  if (!document.body.matches('.page-handle-privacy-policy, .page-handle-terms-conditions')) return;

  const content = document.querySelector('.page-width-content rte-formatter');
  if (!content || content.querySelector('.cactus-policy-toc')) return;

  const headings = [...content.querySelectorAll('h2, h3, h4')].filter((heading) => heading.textContent.trim());
  if (headings.length < 2) return;

  const nav = document.createElement('nav');
  nav.className = 'cactus-policy-toc';
  nav.setAttribute('aria-label', 'On this page');

  const label = document.createElement('p');
  label.className = 'cactus-policy-toc__label';
  label.textContent = 'On this page';

  const links = document.createElement('div');
  links.className = 'cactus-policy-toc__links';

  headings.forEach((heading, index) => {
    const id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
    heading.id = id;

    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = heading.textContent.trim();
    links.append(link);
  });

  nav.append(label, links);
  content.prepend(nav);
});
